var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftLeaf = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 134,
  height: 243,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-47.998 110.341c23.456-2.664 84.32-21.327 148.053 45.585-34.873 13.534-113.307 23.365-148.053-45.585Z",
  fill: "#83AB5B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M-48.494 112.096c7.745-15.728 20.497-61.253 87.883-74.241-5.532 27.224-30.853 80.186-87.883 74.241ZM-37.655 120.968c16.595 5.655 63.382 12.44 84.938 77.593-27.71-1.981-83.49-20.272-84.938-77.593Z",
  fill: "#83AB5B"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M92.764 154.107-36.8 118.669M41.49 193.309l-67.868-52.123M36.538 41.16l-79.98 68.659M24 72.772 3.302 69.265l.618-18.433M-.542 96.63l-17.16-8.377 3.036-26.792M29.873 111.302 3.35 129.355M45.28 165.268l-20.657-29.386M71.433 131.412l-16.918 12.373 14.092 19.339M1.822 151.433l-20.161-27.382M38.828 178.704l-19.11-2.778-1.166 15.751M4.665 163.981l-2.727 19.788",
  stroke: "#000",
  strokeWidth: 1.353
})));
export default SvgLeftLeaf;